// This is a work around
// We can't use remote components in the app that exposes the remote component
// Eventually lapel will properly support dynamic imports
// and we won't need to think about remote components

if (typeof window !== "undefined" && window.dar === undefined) {
  // We need to create a mock host
  // methods required: get, init

  // NOTE: Currently only exposing the recommender carousels
  // Others can be enabled as needed
  const modules = {
    "./recommenders-carousel": () =>
      Promise.resolve(() =>
        require("@lululemon/ecom-site/federated/recommenders-carousel")
      ),
    "./product-list-top-content": () =>
      Promise.resolve(() =>
        require("@lululemon/ecom-site/federated/product-list-top-content")
      ),
    "./card-carousel": () =>
      Promise.resolve(() =>
        require("@lululemon/ecom-site/federated/card-carousel")
      ),
    "./email-banner-form": () =>
      Promise.resolve(() =>
        require("@lululemon/ecom-site/federated/email-banner-form")
      ),
    "./email-banner-modal": () =>
      Promise.resolve(() =>
        require("@lululemon/ecom-site/federated/email-banner-modal")
      ),
  };
  const mockHost = {
    get: (modulePath) => {
      if (modules[modulePath]) {
        return modules[modulePath]();
      }
      return Promise.reject(new Error(`Module ${modulePath} not found`));
    },
    init: () => {
      return null;
    },
  };
  window.dar = mockHost;
}
